<template>
    <div>
       <!--
       <div v-if="lastConfirmedTransferOut">
                <p class="c f130">{{lastConfirmedTransferOut.successCNT }} serials added into transferCode: <b>{{ lastConfirmedTransferOut.transferCode }}</b></p>
                <div class="locationInfos">
                    <input type="text" v-model="fromLocation" placeholder="From Location">
                    <p class="f130"><to-right-icon></to-right-icon></p>
                    <input type="text" v-model="toLocation" placeholder="To Location">
                </div>
                <div class="comment">
                    <textarea v-model="comment" width="100%" rows="2" placeholder="Comment to transfer..."></textarea>
                </div>
                <button class="inp defcolor btn2" @click="updateTransferData">Update Transfer &amp; Continue</button>
            </div>
            <div v-else>
                <div class="form">
                    <div>SN:</div>
                    <input @keypress.enter="scanSN" class="inp big" ref="snfld" type="text"
                           v-model="tmpSN"/>
                </div>
                <div v-if="transferOUT.length">
                    <button :disabled="okItemsCount==0" @click="newOUT" class="inp defcolor btn2">Create New
                        Transfer-Batch from {{okItemsCount}} scanned items
                    </button>
                    <ul class="snlist">
                        <li :class="{ 'notfound': item.icon == 3,
                                'ontrf': item.icon == 4,
                                'ok': item.icon == 1,
                                'dupl': item.icon == 2
                    }"
                            v-for="item in transferOUT.slice().reverse()"><span class="sn" v-text="item.sn"></span>
                            <span class="ponum" v-text="item.itemCode"></span>
                        </li>
                    </ul>
                </div>
            </div>
            -->
    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex'

    export default {
        name: "TransferOUT",
        data() {
            return {

            }
        },
        updated() {
            if (this.$refs.snfld) this.$refs.snfld.focus();
        },
        mounted() {
            this.$store.dispatch('transfer/getTransfers');
        },
    }
</script>

<style scoped>

</style>